import { DeleteOutlined } from '@ant-design/icons';
import { useTranslate } from '@tolgee/react';
import { Button } from 'antd';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useCreateVoucher } from '../../../hooks/graphql/useAddCoupons';
import { showToast } from '../../../utils/commonUtility';
import {
  CartOrderConfirmation,
  ConfirmationModal,
} from '../../requests/confirmation-modal/ConfirmationModal';
import './VoucherOrder.scss';

interface Item {
  id: number;
  price: number;
  quantity: number;
}

const VoucherOrder = ({
  toggleCheckoutSectionVisibility,
}: {
  toggleCheckoutSectionVisibility: (bool: boolean) => any;
}) => {
  const [items, setItems] = useState<Item[]>([
    { id: 1, price: 50.0, quantity: 5 },
  ]);

  const { t } = useTranslate();

  const navigate = useNavigate();
  const [confirmationProps, setConfirmationProps] = useState<boolean>(false);
  const { createVoucherRequest, createOrderLoading } = useCreateVoucher();
  const addItem = () => {
    setItems([...items, { id: Date.now(), price: 50.0, quantity: 5 }]);
  };

  const updateQuantity = (id: number, delta: number) => {
    setItems(
      items.map(item =>
        item.id === id
          ? { ...item, quantity: Math.max(0, item.quantity + delta) }
          : item,
      ),
    );
  };

  const updatePrice = (id: number, price: any) => {
    const parsedPrice = parseFloat(price);
    if (parsedPrice < 0) {
      return;
    }
    setItems(
      items.map(item =>
        item.id === id
          ? { ...item, price: isNaN(parsedPrice) ? 0 : parsedPrice }
          : item,
      ),
    );
  };

  const deleteItem = (id: number) => {
    setItems(items.filter(item => item.id !== id));
  };

  const totalQuantity = items.reduce((sum, item) => sum + item.quantity, 0);
  const totalValue = items.reduce(
    (sum, item) => sum + item.price * item.quantity,
    0,
  );
  const addVouchers = () => {
    createVoucherRequest(
      items.map(i => ({ voucherAmount: i.price, voucherCount: i.quantity })),
      data => {
        if (data?.createVoucherRequest?.data?.voucherRequestId) {
          setConfirmationProps(true);
        } else {
          showToast('something-wrong', 'error');
        }
      },
    );
  };
  return (
    <div className='voucher-order'>
      <div className='voucher-order__left-section'>
        <table className='order-table'>
          <thead>
            <tr>
              <th>{t('value')}</th>
              <th>{t('quantity')}</th>
              <th>{t('total')}</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {items.map(item => (
              <tr key={item.id}>
                <td>
                  <input
                    step='1'
                    min='1'
                    type='number'
                    inputMode='numeric'
                    pattern='[0-9]*'
                    value={item.price.toFixed(0)} // Always display with 0 decimal points
                    onKeyDown={e => {
                      if (e.key === '.' || e.key === 'e' || e.key === 'E') {
                        e.preventDefault();
                      }
                    }}
                    onChange={e =>
                      updatePrice(
                        item.id,
                        parseFloat(parseFloat(e.target.value).toFixed(0)),
                      )
                    }
                  />
                </td>
                <td>
                  <button onClick={() => updateQuantity(item.id, -1)}>-</button>
                  <span>{item.quantity}</span>
                  <button onClick={() => updateQuantity(item.id, 1)}>+</button>
                </td>
                <td>CHF {(item.price * item.quantity).toFixed(0)}</td>
                <td>
                  <button
                    className='delete-btn'
                    onClick={() => deleteItem(item.id)}
                  >
                    <DeleteOutlined />
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        <button className='add-btn' onClick={addItem}>
          + {t('add-more')}
        </button>
      </div>
      <div className='voucher-order__right-section'>
        <div className='summary'>
          <h3>{t('summary')}</h3>
          <p>
            <span>{t('quantity')}:</span> <span>{totalQuantity}</span>
          </p>
          <p className='total'>
            <span>{t('total-value')}:</span>{' '}
            <span>CHF {totalValue.toFixed(0)}</span>
          </p>
          <Button
            className='confirm-btn'
            onClick={addVouchers}
            loading={createOrderLoading}
            disabled={!totalValue}
          >
            {t('confirm-order')}
          </Button>
        </div>
      </div>
      <ConfirmationModal
        isOpen={confirmationProps}
        setOpen={(bool: boolean) => {
          setConfirmationProps(bool);
          toggleCheckoutSectionVisibility(false);
        }}
      >
        <CartOrderConfirmation />
      </ConfirmationModal>
    </div>
  );
};

export default VoucherOrder;
